import logTrackFactory from '@igc-lib/log-track';
import { env } from '@/utils';

// APP/web/wechat/miniprogram
let open_environment = '';
if (env.isApp) {
  open_environment = 'APP';
} else if (env.isWeChat) {
  open_environment = 'wechat';
} else {
  open_environment = 'web';
}

// 站外上报白名单（路由地址）
// '/mall/vipCard', '/mall/vipCard/success'
const whiteList = [];
// 获取路由地址
const path = window.location.pathname;
const isReport = whiteList.some(item => path.includes(item));

let p_env = process.env.VUE_APP_ENVIRONMENT == 'PRODUCTION' ? 'prod' : 'qa';
const logTrackInstance = logTrackFactory(p_env, {
  initConfig: {
    enable_native: false,
    spa: true,
    // autoTrack: true,
  },
  enableAutoPv: env.isApp ? true : false,
  commonParams: {
    web_project_name: '商城H5',
  },
  enableOutAPP: isReport ? true : false,
  requestAutoTrackParams: {
    classKey: 'web_auto_track',
    itemKey: 'project_mall'
  },
});

/* eslint-disable-next-line */
console.log('logTrackInstance~~~', logTrackInstance);
// 通过实例的init方法 在合适的地方进行初始化 一般为入口文件中
logTrackInstance && logTrackInstance.init();
// @aigc:end 2024/03/15-14:30

export default logTrackInstance;
export const commonParams = {
  open_environment,
};